import { getRegisterFunction } from '../../utils/register.js';
import { OneUxFieldSetElement } from './OneUxFieldSetElement.js';
export const register = getRegisterFunction(OneUxFieldSetElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-field-set': OneUxFieldSetElement;
    "field-set-63ec04dcf91b716ef6bbc085908f2b1c": OneUxFieldSetElement;
  }
}